// @flow

import * as React from 'react';
import numeral from 'numeral';
import moment from 'moment';
import glamorous, { Span } from 'glamorous';
import RewriteLink from 'app/components/routing/RewriteLink';
import Tappable from 'app/components/commons/Tappable';
import t from 'app/utils/translate';

type Props = {
  challengeId: string,
  className?: string,
  date: string,
  match: string,
  number?: number,
  score: number,
};

const defaultProps = {
  className: undefined,
  number: undefined,
};

const Bold = glamorous.span(props => ({
  fontWeight: props.theme.fontWeight.bold,
  paddingRight: 4,
}));

const Details = glamorous.div(props => ({
  display: 'flex',
  justifyContent: 'space-around',
  alignItems: 'center',
  fontSize: props.theme.fontSize.tiny,
  color: props.theme.color.white,
  textTransform: 'uppercase',
  maxWidth: '100%',
  flexWrap: 'wrap',
}));

const ConstrainedDiv = glamorous.div(
  {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  props => ({
    maxWidth: props.width,
  }),
);

const FlexDiv = glamorous.div({
  display: 'flex',
  whiteSpace: 'nowrap',
  paddingLeft: 5,
  paddingRight: 5,
});

const OverflowFlexDiv = glamorous(FlexDiv)({
  overflow: 'hidden',
});

const Highlight = glamorous.span(props => ({
  color: props.theme.color.green,
}));

const LinkButton = glamorous(Tappable)({
  overflow: 'hidden',
  display: 'flex',
});

function WinnerDetails({ challengeId, className, date, match, number, score }: Props) {
  return (
    <Details className={className}>
      {number !== undefined && <span>{number}.</span>}
      <FlexDiv>
        <Highlight>{numeral(score).format('0.00')}</Highlight>
      </FlexDiv>
      <OverflowFlexDiv>
        <Bold>{t('Match')}:</Bold>
        <LinkButton component={RewriteLink} to={`/challenge/${challengeId}`}>
          <ConstrainedDiv width="100%">{match}</ConstrainedDiv>
          <Span paddingLeft={4} className="ion-android-open" />
        </LinkButton>
      </OverflowFlexDiv>
      <FlexDiv>
        <Bold>{t('Date')}:</Bold>
        <div>{moment(date).format('ddd, DD MMM YY')}</div>
      </FlexDiv>
    </Details>
  );
}

WinnerDetails.defaultProps = defaultProps;

export default WinnerDetails;
